import React from "react";
import "./App.css";
import Navbar from "./components/Navbar";
import LandingPage from "./pages/LandingPage";
import ExperiencePage from "./pages/ExperiencePage";
import ProjectsPage from "./pages/ProjectsPage";
import { Routes, Route } from "react-router-dom";
import ProjectDescPage from "./pages/ProjectDescPage";
import EducationPage from "./pages/EducationPage";
import Contacts from "./components/Contacts";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        {/* Main Layout */}
        <Route
          path="/"
          element={
            <>
              <div id="home">
                <LandingPage />
              </div>
              <div id="projects" style={{ zIndex: 0, width: "100%" }}>
                <ProjectsPage />
              </div>
              <div className="devider" />
              <div id="experience">
                <ExperiencePage />
              </div>
              <div id="education" style={{ zIndex: 1, width: "100%" }}>
                <EducationPage />
              </div>
              <div className="devider" />
              <div id="contacts" style={{ zIndex: 1, width: "100%" }}>
                <Contacts />
              </div>
            </>
          }
        />

        {/* Project Description Page */}
        <Route path="/projects/:projectId" element={<ProjectDescPage />} />
      </Routes>
    </div>
  );
}

export default App;
